import { render, staticRenderFns } from "./Vars_cufi.vue?vue&type=template&id=0304faca&scoped=true&"
import script from "./Vars_cufi.vue?vue&type=script&lang=js&"
export * from "./Vars_cufi.vue?vue&type=script&lang=js&"
import style0 from "./Vars_cufi.vue?vue&type=style&index=0&id=0304faca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0304faca",
  null
  
)

export default component.exports